var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdminInputSingleSelect',_vm._g(_vm._b({attrs:{"size":_vm.size,"disabled":_vm.disabled},on:{"change":_vm.update}},'AdminInputSingleSelect',Object.assign({}, _vm.$attrs, _vm.$props),false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }